import { render } from "./button-group.vue?vue&type=template&id=2ad03c66"
import script from "./button-group.vue?vue&type=script&lang=js"
export * from "./button-group.vue?vue&type=script&lang=js"

import "./button-group.vue?vue&type=style&index=0&id=2ad03c66&lang=less"

import exportComponent from "/var/jenkins_home/workspace/prod/bijixia-wx-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__